import React, { useState, useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import EditorConvertToMarkdown from "../EditorConvertToMarkdown";
import {
  ContentFields,
  ContentButtonsVariables,
  ContentControlVariables,
  ButtonBodyVariables,
  ButtonSubjectVariables,
  ContentButtons,
  ButtonSave,
} from "./SOSNotification.styled";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const SOSNotification = ({ body, setBody, saveTemplate, subject }) => {
  const [subjectValue, setSubjectValue] = useState({
    target: {
      value: "",
    },
  });
  const [variableSelected, setVariableSelected] = useState();
  const [variableActived, setVariableActived] = useState();
  const [sendSubjectVariable, setSendSubjectVariable] = useState();
  const [sendBodyVariable, setSendBodyVariable] = useState();
  const variables = [
    {
      label: "Username",
      value: 1,
      identity: "%username%",
    },
    {
      label: "Last name",
      value: 2,
      identity: "%lastname%",
    },
    {
      label: "First name",
      value: 3,
      identity: "%firstname%",
    },
    {
      label: "Tp id",
      value: 4,
      identity: "%tpid%",
    },
    {
      label: "Country",
      value: 5,
      identity: "%country%",
    },
    {
      label: "City",
      value: 6,
      identity: "%city%",
    },
  ];
  let handleChangeVariable = (event) => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    setVariableSelected(value);
    setVariableActived(JSON.parse(value));
  };

  let handleSendVariablesSubject = () => {
    setSendSubjectVariable(variableActived?.identity);
  };

  let handleSendVariablesBody = () => {
    setSendBodyVariable(variableActived?.identity);
  };

  useEffect(() => {
    if (subjectValue && sendSubjectVariable) {
      let cursorPosition = subjectValue.target.selectionStart;
      let textBeforeCursorPosition = subjectValue.target.value.substring(
        0,
        cursorPosition
      );
      let textAfterCursorPosition = subjectValue.target.value.substring(
        cursorPosition,
        subjectValue.target.value.length
      );
      subjectValue.target.value =
        textBeforeCursorPosition +
        sendSubjectVariable +
        textAfterCursorPosition;
      setSendSubjectVariable();
    }
  }, [subjectValue, sendSubjectVariable]);

  useEffect(() => {
    if (subject) subjectValue.target.value = subject;
  }, [subject]);

  return (
    <>
      <ContentFields>
        <Row className="w-100">
          <Col md={8} style={{ paddingRight: "2em" }}>
            <Form.Label>
              Subject
              <span style={{ color: "red" }}> *</span>
            </Form.Label>{" "}
            <Form.Control
              type="text"
              placeholder="Type subject here"
              value={subjectValue.target.value ? subjectValue.target.value : ""}
              onChange={(e) => {
                setSubjectValue(e);
              }}
            />
            <Form.Label className="mt-3">
              Body
              <span style={{ color: "red" }}> *</span>
            </Form.Label>{" "}
            <EditorConvertToMarkdown
              editor={body}
              setEditor={setBody}
              sendVariable={sendBodyVariable}
              style={{ width: "100%" }}
              showOnFocus={false}
            />
          </Col>
          <Col md={4}>
            <Form.Label className="text-bold">Available variables</Form.Label>{" "}
            <p style={{ width: "397px" }}>
              *Click on the parameter you want to add to your email template.
              The parameter will be added where the cursor is in the subject or
              body fields.
            </p>
            <ContentControlVariables>
              <FormControl
                sx={{
                  m: 0,
                  marginBottom: 3,
                  width: "100%",
                  maxWidth: 397,
                }}
              >
                <Select
                  multiple
                  native
                  value={variableSelected}
                  onChange={handleChangeVariable}
                  label="Native"
                  inputProps={{
                    id: "select-multiple-native",
                  }}
                >
                  {variables.map((element) => (
                    <option key={element.value} value={JSON.stringify(element)}>
                      {element.label}
                    </option>
                  ))}
                </Select>
              </FormControl>{" "}
            </ContentControlVariables>
            <ContentButtonsVariables>
              <ButtonSubjectVariables
                onClick={() => handleSendVariablesSubject()}
              >
                Add to Subject
              </ButtonSubjectVariables>
              <ButtonBodyVariables onClick={() => handleSendVariablesBody()}>
                Add to Body
              </ButtonBodyVariables>
            </ContentButtonsVariables>
          </Col>
        </Row>
      </ContentFields>
      <ContentButtons>
        <ButtonSave
          disabled={
            body === "" ||
            body.trim() === "<p></p>" ||
            !subjectValue.target.value
          }
          onClick={() => {
            saveTemplate(subjectValue.target.value, body);
          }}
        >
          Save Changes
        </ButtonSave>
      </ContentButtons>
    </>
  );
};

export default SOSNotification;
